import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["regionCheckbox", "prefectureCheckbox"];

  connect() {
    this.updateRegionCheckboxes();
  }

  updateRegionCheckboxes() {
    const nationwide = this.regionCheckboxTargets.find(cb => cb.id === 'nationwide');
    nationwide.checked = this.prefectureCheckboxTargets.length > 0 && this.prefectureCheckboxTargets.every(cb => cb.checked);

    this.regionCheckboxTargets.forEach(regionCheckbox => {
      if (regionCheckbox.id === 'nationwide') return;

      const regionDiv = regionCheckbox.closest('.search-modal__region');
      if (!regionDiv) return;
      const checkboxes = regionDiv.querySelectorAll('[data-region-prefecture-list-target="prefectureCheckbox"]');
      if (checkboxes.length > 0 && Array.from(checkboxes).some(cb => cb.checked)) {
        regionCheckbox.checked = true;
      } else {
        regionCheckbox.checked = false;
      }
    });
  }

  checkedToggleAll(event) {
    const checked = event.target.checked;
    if (event.target.id === 'nationwide') {
      this.prefectureCheckboxTargets.forEach((checkbox) => {
        checkbox.checked = checked;
        checkbox.dispatchEvent(new Event("change", { bubbles: true }));
      });
      this.regionCheckboxTargets.forEach((regionCheckbox) => {
        regionCheckbox.checked = checked;
      });
      return;
    }

    const regionDiv = event.target.closest('.search-modal__region');
    if (!regionDiv) return;
    const checkboxes = regionDiv.querySelectorAll('[data-region-prefecture-list-target="prefectureCheckbox"]');
    checkboxes.forEach((checkbox) => {
      checkbox.checked = checked;
      checkbox.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }
}
